import { SplitViewContext } from '../components/split_view';
import { useContext }       from 'react';
import CheckAccess          from './check_access';
import CheckOnboarding      from './check_onboarding';
import classnames           from 'classnames';
import React                from 'react';


const PageContext = React.createContext({});

export default function renderPage(Component, { className } = {}) {
  return class RenderPage extends React.Component {

    constructor(props) {
      super(props);

      this.makePath       = this.makePath.bind(this);
      this.navigateBackTo = this.navigateBackTo.bind(this);
      this.navigateTo     = this.navigateTo.bind(this);
    }

    makePath(path) {
      const app = this.$f7;
      return app.methods.makePath({ app, path });
    }

    navigateTo(path, options) {
      const app = this.$f7;
      app.methods.navigateTo({ app, path, options });
    }

    navigateBackTo(path, options) {
      const app = this.$f7;
      app.methods.navigateBackTo({ app, path, options });
    }

    render() {
      const route      = this.$f7route;
      const { path }   = route;
      const { query }  = route;
      const { params } = route;

      const { navigateBackTo } = this;
      const { navigateTo }     = this;
      const { makePath }       = this;

      const pageProps = {
        ...params,
        query,
        navigateBackTo,
        navigateTo,
        makePath
      };

      const { businessID } = params;
      const classNames     = classnames('page', className);

      return (
        <div className={classNames}>
          <PageContext.Provider value={pageProps}>
            <CheckAccess businessID={businessID} navigateTo={this.navigateTo}>
              <CheckOnboarding businessID={businessID} navigateTo={this.navigateTo} path={path}>
                <SplitViewContext.Consumer>
                  {isSplitView => (
                    <Component {...this.props} {...pageProps} isSplitView={isSplitView}/>
                  )}
                </SplitViewContext.Consumer>
              </CheckOnboarding>
            </CheckAccess>
          </PageContext.Provider>
        </div>
      );
    }
  };
}

export function usePageContext() {
  return useContext(PageContext);
}
